import APIService from "./APIService";
import APIServiceFile from "./ApiServiceFile"
import { API_QUANTRAC_URI } from "../config";

//      project: "cscore.quantrac"
export default class Api_quantrac {
  //TODO: [Common] GET TPMT
  GetDM_TPMTs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DM_TPMT`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };
  //TODO: [Common] GET TPMT by id
  GetDM_TPMT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DM_TPMT/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post TPMT
  PostDM_TPMT = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DM_TPMT`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put TPMT
  PutDM_TPMT = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).putData({
      path: `DM_TPMT?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Delete TPMT
  DeleteDM_TPMT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `DM_TPMT/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET bao cao phe duyet
  GetDTMs = async ({ token, strSearch, hieuluc, roledvhc, madvhc, namcapphep, namhethan, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke, page, size, isBCDK } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM`,
      project: "cscore.quantrac",
      data: { strSearch, hieuluc, roledvhc, madvhc, namcapphep, namhethan, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke, page, size, isBCDK }
    });
  };

  //TODO: [Common] GET bao cao phe duyet by id
  GetDTM = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post bao cao phe duyet
  PostDTM = async ({ token, objdean } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM`,
      project: "cscore.quantrac",
      data: objdean
    });
  };
  //TODO: [Common] Put bao cao phe duyet
  PutDTM = async ({ token, id, objdean } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM/PutDTM?id=${id}`,
      project: "cscore.quantrac",
      data: objdean
    });
  };
  //TODO: [Common] Delete bao cao phe duyet
  DeleteDTM = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM/DeleteDTM?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET tieu quy chuan by thanh phan mt
  GetQuyChuanByDoiTuong = async ({ token, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_TNN/bydoituong?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET tmuc dich su dung by dmqcvn
  GetQT_MucDichSuDungs = async ({ token, page, size, IdDM_QCVN, strSearch } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_MucDichSuDung`,
      data: { page, size, IdDM_QCVN, strSearch },
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] GET bvmt de an chi tiet
  GetBVMTs = async ({ token, strSearch, hieuluc, roledvhc, madvhc, namcapphep, namhethan, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke, page, size, isBCDK } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT`,
      project: "cscore.quantrac",
      data: { strSearch, hieuluc, roledvhc, madvhc, namcapphep, namhethan, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke, page, size, isBCDK }
    });
  };

  //TODO: [Common] GET bvmt kqqt
  GetBVMT_KQQT = async ({ token, thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT/KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt }
    });
  };
  //TODO: [Common] GET bvmt kqqt by thong so
  GetBVMT_KQQT_By_ThongSo = async ({ token, thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD }
    });
  };

  //TODO: [Common] GET tmuc dich su dung by dmqcvn
  GetDTMs_By_DoanhNghiep = async ({ token, page, size, iddoanhnghiep } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM/GetByDoanhNghiep`,
      data: { page, size, iddoanhnghiep },
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] GET bvmt de an chi tiet by id
  GetBVMT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post bvmt de an chi tiet
  PostBVMT = async ({ token, objdean } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT`,
      project: "cscore.quantrac",
      data: objdean
    });
  };
  //TODO: [Common] Put bvmt de an chi tiet
  PutBVMT = async ({ token, id, objdean } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT/PutBVMT?id=${id}`,
      project: "cscore.quantrac",
      data: objdean
    });
  };
  //TODO: [Common] Delete bvmt de an chi tiet
  DeleteBVMT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT/DeleteBVMT?id${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET bvmt kqqt
  GetDTM_KQQT = async ({ token, thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM/KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt }
    });
  };
  //TODO: [Common] GET bvmt kqqt by thong so
  GetDTM_KQQT_By_ThongSo = async ({ token, thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD }
    });
  };

  //TODO: [Common] GET tram qt dtm
  GetDTM_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_TramQuanTrac?strSearch=${strSearch}&page=${page}&size=${size}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET tram qt dtm by quyet dinh
  GetDTM_TramQuanTracs_By_DTM = async ({ token, idThongTinChung, page, size, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_TramQuanTrac/ByDTM`,
      data: { idThongTinChung, page, size, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET tram qt dtm by id
  GetDTM_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post tram qt dtm
  PostDTM_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put tram qt dtm
  PutDTM_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_TramQuanTrac/PutDTM_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Delete tram qt dtm
  DeleteDTM_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_TramQuanTrac/DeleteDTM_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET bao cao dinh ky dtm
  GetDTM_BaoCaoDinhKys = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy?strSearch=${strSearch}&page=${page}&size=${size}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET bao cao dinh ky dtm by id
  GetDTM_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post bao cao dinh ky dtm
  PostDTM_BaoCaoDinhKy = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put bao cao dinh ky dtm
  PutDTM_BaoCaoDinhKy = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy/PutDTM_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Delete bao cao dinh ky dtm
  DeleteDTM_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy/DeleteDTM_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  GetTPMT_Exist_DTM = async ({ token, id_thongtinchung, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/TPMT_Exist`,
      data: { id_thongtinchung, id_tramqt },
      project: "cscore.quantrac"
    });
  };

  GetThongSos_Exist_DTM = async ({ token, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/ThongSos_Exist`,
      data: { id_thongtinchung, id_tramqt, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  GetMauQTs_By_TramQT_DTM = async ({ token, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/MauQTs_By_TramQT`,
      data: { id_thongtinchung, id_tramqt, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  GetBieuDo_SoLanVuotNguong_DTM = async ({ token, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/BieuDo_SoLanVuotNguong`,
      data: { id_thongtinchung, id_tramqt, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  GetBieuDo_ThongSos_GiaTris_Timeline_DTM = async ({ token, idthongso, idthongso2, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/BieuDo_ThongSos_GiaTris_Timeline`,
      data: { idthongso, idthongso2, id_thongtinchung, id_tramqt, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET ntts quyet dinh phe duyet
  GetNTTSs = async ({ token, strSearch, hieuluc, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS?strSearch=${strSearch}&hieuluc=${hieuluc}&page=${page}&size=${size}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET ntts quyet dinh phe duyett by id
  GetNTTS = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post ntts quyet dinh phe duyet
  PostNTTS = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put ntts quyet dinh phe duyet
  PutNTTS = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).putData({
      path: `NTTS?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Delete ntts quyet dinh phe duyet
  DeleteNTTS = async ({ token, id } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `NTTS/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thiet lap mau by idthongtinchung
  Get_BCDK_ThietLapMau = async ({ token, idThongTinChung, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/Get_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post thiet lap mau by idthongtinchung
  Post_BCDK_ThietLapMau = async ({ token, idThongTinChung, thietlapmaus, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy/Post_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };
  // Danh muc quan trac

  //TODO: [Common] GET DM muc dich su dung by id
  GetQT_MucDichSuDung = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_MucDichSuDung/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post DM muc dich su dung
  PostQT_MucDichSuDung = async ({ token, objmucdich, IdDM_QCVN } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_MucDichSuDung?IdDM_QCVN=${IdDM_QCVN}`,
      project: "cscore.quantrac",
      data: objmucdich
    });
  };
  //TODO: [Common] Put DM muc dich su dung
  PutQT_MucDichSuDung = async ({ token, id, objmucdich } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_MucDichSuDung/PutQT_MucDichSuDung?id=${id}`,
      project: "cscore.quantrac",
      data: objmucdich
    });
  };
  //TODO: [Common] Delete DM muc dich su dung
  DeleteQT_MucDichSuDung = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_MucDichSuDung/DeleteQT_MucDichSuDung?id=${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] GET doi tuong QT
  GetDoiTuongQTs = async ({ token, data } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DMChung/doituongqt`,
      data: [data],
      project: "cscore.quantrac"
    });
  };


  //TODO: [Common] Put QCVN TNN
  PutQT_QCVN_TNN = async ({ token, id, Obj } = {}) => {
    return new APIService({ token: token }).putData({
      path: `QT_QCVN_TNN/${id}`,
      project: "cscore.quantrac",
      data: Obj
    });
  };
  //TODO: [Common] Delete QCVN TNN
  Delete_QT_QCVN_TNN = async ({ token, idDM_QCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_QCVN_TNN/delete?idDM_QCVN=${idDM_QCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET QCDT init
  GetQT_QCVN_TNN_Init = async ({ token, idquychuan } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_QCVN_TNN/khoitao?idquychuan=${idquychuan}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET QCVN by mdsd
  GetQT_QCVN_TNN_By_MDSD = async ({ token, idquychuan, idmdsd } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_QCVN_TNN/getbymdsd?idquychuan=${idquychuan}&idmdsd=${idmdsd}`,
      project: "cscore.quantrac"
    });
  };


  //TODO: [Common] GET tieu chuan ap dung
  GetQT_DMQCVN_TNNs = async ({ token, strSearch, page, size, doituongQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_TNN?tpmt_ma=${doituongQT}&page=${page}&size=${size}&strSearch=${strSearch}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET tieu chuan ap dung by id
  GetQT_DMQCVN_TNN = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_TNN/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Put tieu chuan ap dung
  PutQT_DMQCVN_TNN = async ({ token, id, dmqcvn_input } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DMQCVN_TNN/PutQT_DMQCVN_TNN?id=${id}`,
      project: "cscore.quantrac",
      data: dmqcvn_input
    });
  };

  //TODO: [Common] Post tieu chuan ap dung
  PostQT_DMQCVN_TNN = async ({ token, dmqcvn_input, doituongQT } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DMQCVN_TNN?doituongqt=${doituongQT}`,
      data: dmqcvn_input,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Delete tieu chuan ap dung
  DeleteQT_DMQCVN_TNN = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DMQCVN_TNN/DeleteQT_DMQCVN_TNN?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET phuong phap lay mau
  GetQT_PhuongPhapLMs = async ({ token, page, size, IdDM_QCVN, strSearch } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_PhuongPhapLM`,
      data: { page, size, IdDM_QCVN, strSearch },
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET phuong phap lay mau
  GetQT_PhuongPhapLM = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_PhuongPhapLM/${id}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Post phuong phap lay mau
  PostQT_PhuongPhapLM = async ({ token, objphuonghapLM, IdDM_QCVN } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapLM?IdDM_QCVN=${IdDM_QCVN}`,
      project: "cscore.quantrac",
      data: objphuonghapLM
    });
  };
  //TODO: [Common] Put phuong phap lay mau
  PutQT_PhuongPhapLM = async ({ token, id, objphuonghapLM } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapLM/PutQT_PhuongPhapLM?id=${id}`,
      project: "cscore.quantrac",
      data: objphuonghapLM
    });
  };
  //TODO: [Common] Delete phuong phap lay mau
  DeleteQT_PhuongPhapLM = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapLM/DeleteQT_PhuongPhapLM?id=${id}`,
      project: "cscore.quantrac"
    });
  };


  //TODO: [Common] GET phuong phap pt
  GetQT_PhuongPhapPTs = async ({ token, page, size, strSearch } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_PhuongPhapPT`,
      data: { page, size, strSearch },
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET phuong phap pt
  GetQT_PhuongPhapPT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_PhuongPhapPT/${id}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Post phuong phap pt
  PostQT_PhuongPhapPT = async ({ token, objPhuongPhapPT } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapPT`,
      project: "cscore.quantrac",
      data: objPhuongPhapPT
    });
  };
  //TODO: [Common] Put phuong phap pt
  PutQT_PhuongPhapPT = async ({ token, id, objPhuongPhapPT } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapPT/PutQT_PhuongPhapPT?id=${id}`,
      project: "cscore.quantrac",
      data: objPhuongPhapPT
    });
  };
  //TODO: [Common] Delete phuong phap pt
  DeleteQT_PhuongPhapPT = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_PhuongPhapPT/DeleteQT_PhuongPhapPT?id=${id}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET tuyen quan trac
  GetQT_TuyenQuanTracs = async ({ token, page, size, strSearch } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TuyenQuanTrac`,
      data: { page, size, strSearch },
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET tuyen quan trac
  GetQT_TuyenQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TuyenQuanTrac/${id}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Post tuyen quan trac
  PostQT_TuyenQuanTrac = async ({ token, objTuyenQuanTrac } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_TuyenQuanTrac`,
      project: "cscore.quantrac",
      data: objTuyenQuanTrac
    });
  };
  //TODO: [Common] Put tuyen quan trac
  PutQT_TuyenQuanTrac = async ({ token, id, objTuyenQuanTrac } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_TuyenQuanTrac/PutQT_TuyenQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: objTuyenQuanTrac
    });
  };
  //TODO: [Common] Delete tuyen quan trac
  DeleteQT_TuyenQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_TuyenQuanTrac/DeleteQT_TuyenQuanTrac?id=${id}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET don vi thuc hien
  GetQT_DonViThucHiens = async ({ token, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DonViThucHien?page=${page}&size=${size}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET don vi thuc hien
  GetQT_DonViThucHien = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DonViThucHien/${id}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Post don vi thuc hien
  PostQT_DonViThucHien = async ({ token, objdvthuchien } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DonViThucHien`,
      project: "cscore.quantrac",
      data: objdvthuchien
    });
  };
  //TODO: [Common] Put don vi thuc hien
  PutQT_DonViThucHien = async ({ token, id, objdvthuchien } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DonViThucHien/PutQT_DonViThucHien?id=${id}`,
      project: "cscore.quantrac",
      data: objdvthuchien
    });
  };
  //TODO: [Common] Delete don vi thuc hien
  DeleteQT_DonViThucHien = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DonViThucHien/DeleteQT_DonViThucHien?id=${id}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET thong so QT TNN
  GetQT_ThongSo_TNNs = async ({ token, strSearch, page, size, } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_ThongSo?strSearch=${strSearch}&page=${page}&size=${size}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET thong so QT TNN by id
  GetQT_ThongSo_TNN = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_ThongSo/${id}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] Post thong so QT TNN
  PostQT_ThongSo_TNN = async ({ token, thongso_TNN } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_ThongSo`,
      data: thongso_TNN,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] Put thong so QT TNN
  PutQT_ThongSo_TNN = async ({ token, id, thongso_TNN } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_ThongSo/PutQT_ThongSo?id=${id}`,
      data: thongso_TNN,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Delete thong so QT_ThongSo_TNN
  DeleteQT_ThongSo_TNN = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_ThongSo/DeleteQT_ThongSo?id=${id}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET tram quan trac kttv
  GetQT_TramQuanTracs = async ({ token, strSearch, page, size, tpmt_ma, loaiTram } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TramQuanTrac?strSearch=${strSearch}&page=${page}&size=${size}&tpmt_ma=${tpmt_ma}&loaiTram=${loaiTram}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] GET tram quan trac kttv by id 
  GetQT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TramQuanTrac/${id}`,
      project: "cscore.quantrac"
    });
  };
  //TODO: [Common] Post tram quan trac kttv
  PostQT_TramQuanTrac = async ({ token, quanTrac, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_TramQuanTrac?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: quanTrac
    });
  };

  //TODO: [Common] Put tram quan trac kttv
  PutQT_TramQuanTrac = async ({ token, id, quanTrac } = {}) => {
    return new APIService({ token: token }).putData({
      path: `QT_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
      data: quanTrac
    });
  };
  //TODO: [Common] Delete tram quan trac kttv
  DeleteQT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `QT_TramQuanTrac/${id}`,
      project: "cscore.quantrac"
    });
  };


  //TODO: [Common] GET cau hinh thong so by tpmt
  GetQT_TPMT_ThongSos = async ({ token, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TPMT_ThongSos?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thong so by tpmt
  GetQT_ThongSos_By_TPMT = async ({ token, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_TPMT_ThongSos/ThongSos_By_TPMT?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] GET bcdk kqqt
  GetBCDK_KQQT = async ({ token, thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] GET bcdk kqqt by thong so
  GetBCDK_KQQT_By_ThongSo = async ({ token, thongso_id, thongtinchung_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD, id_TramQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD, id_TramQT }
    });
  };

  //TODO: [Common] Post thong so by tpmt
  PostQT_TPMT_ThongSos = async ({ token, objs, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_TPMT_ThongSos?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: objs
    });
  };
  //TODO: [Common] GET tree DTM bao cao dinh ky
  Get_DTM_BaoCaoDinhKy = async ({ token, strSearch, kybaocao, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/Get_Trees`,
      project: "cscore.quantrac",
      data: { kybaocao, strSearch, page, size }
    });
  };

  //TODO: [Common] GET dtm theo gp
  GetBCDK_By_QD = async ({ token, thongtinchung_id, nam, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy/BCDK_By_QD`,
      data: { thongtinchung_id, nam, page, size },
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET QCVN TNN
  GetQT_QCVN_TNNs = async ({ token, strSearch, page, size, DMQCID } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_QCVN_TNN?DMQCID=${DMQCID}&page=${page}&size=${size}&strSearch=${strSearch}`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] Post QCVN TNN
  PostQT_QCVN_TNN = async ({ token, Objs, idDM_QCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_QCVN_TNN?idDM_QCVN=${idDM_QCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      data: Objs
    });
  };

  //TODO: [Common] Post cau hinh don vi dtm
  LuuCauHinhDVT = async ({ token, obj } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM/luucauhinhdvt`,
      project: "cscore.quantrac",
      data: obj
    });
  };

  //TODO: [Common] GET cau hinh don vi dtm
  UtilThemMoi = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM/UtilThemMoi`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] Post cau hinh don vi bvmt
  LuuCauHinhDVTBVMT = async ({ token, obj } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT/luucauhinhdvt`,
      project: "cscore.quantrac",
      data: obj
    });
  };

  //TODO: [Common] GET cau hinh don vi bvmt
  UtilThemMoiBVMT = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT/UtilThemMoi`,
      project: "cscore.quantrac"
    });
  };

  //TODO: [Common] GET BVMT BCDK
  GetBVMT_BaoCaoDinhKys = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET BVMT BCDK by id
  GetBVMT_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post BVMT BCDK
  PostBVMT_BaoCaoDinhKy = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put BVMT BCDK
  PutBVMT_BaoCaoDinhKy = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy/PutBVMT_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete ntts quyet dinh phe duyet
  DeleteBVMT_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy/DeleteBVMT_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thiet lap mau BVMT BCDK by idThongTinChung
  Get_BCDK_ThietLapMau_BVMT = async ({ token, idThongTinChung, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/Get_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET BCDK_By_QD
  GetBCDK_By_QD_BVMT = async ({ token, thongtinchung_id, nam, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/BCDK_By_QD`,
      data: { thongtinchung_id, nam, page, size },
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau BVMT BCDK by idThongTinChung
  Post_BCDK_ThietLapMau_BVMT = async ({ token, idThongTinChung, thietlapmaus, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy/Post_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET tree BVMT BCDK
  Get_BVMT_BaoCaoDinhKy = async ({ token, kybaocao, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/Get_Trees`,
      project: "cscore.quantrac",
      data: { kybaocao, strSearch, page, size }
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc của báo cáo định kỳ theo báo cáo phê duyệt
  GetBCDK_KQQT_BVMT = async ({ token, thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc theo thong so
  GetBCDK_KQQT_By_ThongSo_BVMT = async ({ token, thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT }
    });
  };

  //TODO: [Common] get tpmt tho tram
  GetTPMT_Exist_BVMT = async ({ token, id_thongtinchung, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/TPMT_Exist`,
      project: "cscore.quantrac",
      data: { id_thongtinchung, id_tramqt }
    });
  };

  GetThongSos_Exist_BVMT = async ({ token, id_thongtinchung, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/ThongSos_Exist`,
      project: "cscore.quantrac",
      data: { id_thongtinchung, tpmt_ma, id_tramqt }
    });
  };

  GetMauQTs_By_TramQT_BVMT = async ({ token, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/MauQTs_By_TramQT`,
      project: "cscore.quantrac",
      data: { id_thongtinchung, id_tramqt, tpmt_ma }
    });
  };

  GetBieuDo_SoLanVuotNguong_BVMT = async ({ token, id_thongtinchung, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/BieuDo_SoLanVuotNguong`,
      project: "cscore.quantrac",
      data: { id_thongtinchung, tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_ThongSos_GiaTris_Timeline_BVMT = async ({ token, idthongso, idthongso2, id_thongtinchung, id_tramqt, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy/BieuDo_ThongSos_GiaTris_Timeline`,
      project: "cscore.quantrac",
      data: { idthongso, idthongso2, id_thongtinchung, id_tramqt, tpmt_ma }
    });
  };

  //TODO: [Common] GET BVMT BCDK
  GetBVMTs_By_DoanhNghiep = async ({ token, iddoanhnghiep, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT/GetByDoanhNghiep`,
      project: "cscore.quantrac",
      data: { iddoanhnghiep, page, size }
    });
  };

  //TODO: [Common] GET tram by BVMT BCDK
  GetBVMT_TramQuanTracs_By_BVMT = async ({ token, idThongTinChung, tpmt_ma, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_TramQuanTrac/ByBVMT`,
      project: "cscore.quantrac",
      data: { idThongTinChung, page, size, tpmt_ma }
    });
  };


  //TODO: [Common] GET BVMT tram qt
  GetBVMT_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET BVMT tram qt by id
  GetBVMT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post BVMT tram qt
  PostBVMT_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put BVMT tram qt
  PutBVMT_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).putData({
      path: `BVMT_TramQuanTrac/PutBVMT_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete tram qt bvmt
  DeleteBVMT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_TramQuanTrac/DeleteBVMT_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET NTTS BCDK
  GetNTTS_BaoCaoDinhKys = async ({ token, strSearch, page, size, kybaocao } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, kybaocao }
    });
  };

  //TODO: [Common] GET NTTS BCDK by id
  GetNTTS_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post NTTS BCDK
  PostNTTS_BaoCaoDinhKy = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put NTTS BCDK
  PutNTTS_BaoCaoDinhKy = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy/PutNTTS_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete ntts quyet dinh phe duyet
  DeleteNTTS_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy/DeleteNTTS_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET tree NTTS bao cao dinh ky
  Get_NTTS_BaoCaoDinhKy_Tree = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy/Get_Trees`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET thiet lap mau NTTS BCDK by idThongTinChung
  Get_BCDK_ThietLapMau_NTTS = async ({ token, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy/Get_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau NTTS BCDK by idThongTinChung
  Post_BCDK_ThietLapMau_NTTS = async ({ token, thietlapmaus, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy/Post_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc của báo cáo định kỳ theo báo cáo phê duyệt
  GetBCDK_KQQT_NTTS = async ({ token, tpmt_ma, idbaocao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, idbaocao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  GetBCDK_KQQT_By_ThongSo_NTTS = async ({ token, thongso_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_BaoCaoDinhKy/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD }
    });
  };


  //TODO: [Common] GET NTTS tram qt
  GetNTTS_TramQuanTracs = async ({ token, strSearch, page, size, tpmt_ma, idbaocao } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, tpmt_ma, idbaocao }
    });
  };

  //TODO: [Common] GET NTTS tram qt by id
  GetNTTS_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post NTTS tram qt
  PostNTTS_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put NTTS tram qt
  PutNTTS_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_TramQuanTrac/PutNTTS_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete tram qt NTTS
  DeleteNTTS_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_TramQuanTrac/DeleteNTTS_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  GetTPMT_Exist_NTTS = async ({ token, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/TPMT_Exist`,
      project: "cscore.quantrac",
      data: { id_tramqt }
    });
  };

  GetThongSos_Exist_NTTS = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/ThongSos_Exist`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetMauQTs_By_TramQT_NTTS = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/MauQTs_By_TramQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_SoLanVuotNguong_NTTS = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/BieuDo_SoLanVuotNguong`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_ThongSos_GiaTris_Timeline_NTTS = async ({ token, idthongso, idthongso2, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `NTTS_TramQuanTrac/BieuDo_ThongSos_GiaTris_Timeline`,
      project: "cscore.quantrac",
      data: { idthongso, idthongso2, tpmt_ma, id_tramqt }
    });
  };

  DownloadFileDTM = async ({ token, strSearch, hieuluc, roledvhc, madvhc, namcapphep, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `ThongKeDSDeAnDTM/download?cache=no&strSearch=${strSearch}&roledvhc=${roledvhc}&hieuluc=${hieuluc}&madvhc=${madvhc}&namcapphep=${namcapphep}&giatri_tlkt=${giatri_tlkt}&truluongkt=${truluongkt}&giatri_cstk=${giatri_cstk}&congsuatthietke=${congsuatthietke}`,
      project: "cscore.quantrac",
      fileName: 'TTDanhSachDeAnDTM.xlsx'
    });
  }

  DownloadFileBVMT = async ({ token, strSearch, hieuluc, roledvhc, madvhc, namcapphep, giatri_tlkt, truluongkt, giatri_cstk, congsuatthietke } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `ThongKeDSDeAnBVMT/download?cache=no&strSearch=${strSearch}&roledvhc=${roledvhc}&hieuluc=${hieuluc}&madvhc=${madvhc}&namcapphep=${namcapphep}&giatri_tlkt=${giatri_tlkt}&truluongkt=${truluongkt}&giatri_cstk=${giatri_cstk}&congsuatthietke=${congsuatthietke}`,
      project: "cscore.quantrac",
      fileName: 'TTDanhSachDeAnBVMT.xlsx'
    });
  }

  DownloadFileTraCuuDoanhNghiep = async ({ token, strSearch, dulieu_doanhnghiep } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DuLieu_DoanhNghiep/Download_KQTimKiem_By_DoanhNghiep?cache=no&strSearch=${strSearch}`,
      data: dulieu_doanhnghiep,
      project: "cscore.quantrac",
      fileName: 'KQTimKiem_DoanhNghiep.xlsx'
    });
  }

  //TODO: [Common] GET HTMT 
  GetHTMT_BaoCaoDinhKys = async ({ token, strSearch, page, size, kybaocao } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, kybaocao }
    });
  };

  //TODO: [Common] GET HTMT by id
  GetHTMT_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET tree HTMT
  Get_HTMT_BaoCaoDinhKy_tree = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy/Get_Trees`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET dkqqt htmt theo id
  GetBCDK_KQQT_HTMT = async ({ token, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] GET danh sách kết quả quan trắc theo thong so HTMT
  GetBCDK_KQQT_By_ThongSo_HTMT = async ({ token, thongso_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD, id_TramQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, kybaocao, tpmt_ma, idDMQCVN, idMDSD, id_TramQT }
    });
  };

  //TODO: [Common] Post htmt
  PostHTMT_BaoCaoDinhKy = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put htmt
  PutHTMT_BaoCaoDinhKy = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy/PutHTMT_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete htmt
  DeleteHTMT_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy/DeleteHTMT_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thiet lap mau kqqt htmt
  Get_BCDK_ThietLapMau_HTMT = async ({ token, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_BaoCaoDinhKy/Get_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau htmt
  Post_BCDK_ThietLapMau_HTMT = async ({ token, thietlapmaus, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy/Post_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET tram qt HTMT
  GetHTMT_TramQuanTracs = async ({ token, strSearch, page, size, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, tpmt_ma }
    });
  };

  //TODO: [Common] GET tram by id
  GetHTMT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post tram HTMT
  PostHTMT_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put tram htmt
  PutHTMT_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_TramQuanTrac/PutHTMT_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete tram htmt
  DeleteHTMT_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_TramQuanTrac/DeleteHTMT_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  GetTPMT_Exist_HTMT = async ({ token, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/TPMT_Exist`,
      project: "cscore.quantrac",
      data: { id_tramqt }
    });
  };

  GetThongSos_Exist_HTMT = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/ThongSos_Exist`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetMauQTs_By_TramQT_HTMT = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/MauQTs_By_TramQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_SoLanVuotNguong_HTMT = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/BieuDo_SoLanVuotNguong`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_ThongSos_GiaTris_Timeline_HTMT = async ({ token, tpmt_ma, id_tramqt, idthongso, idthongso2 } = {}) => {
    return new APIService({ token: token }).getData({
      path: `HTMT_TramQuanTrac/BieuDo_ThongSos_GiaTris_Timeline`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt, idthongso, idthongso2 }
    });
  };

  //TODO: [Common] GET du lieu by doanh nghiep
  GetDSDuLieuByIDDoanhNghiep = async ({ token, iddoanhnghiep } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DuLieu_DoanhNghiep`,
      data: iddoanhnghiep,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET log
  SearchLog = async ({ token, page, size, searchText, from, to } = {}) => {
    return new APIService({ token: token }).getData({
      path: `log/SearchLog`,
      project: "cscore.quantrac",
      data: { page, size, searchText, from, to }
    });
  };

  //TODO: [Common] Delete log
  DeleteLog = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `log/deletelog?id=${id}`,
      project: "cscore.quantrac",
    });
  };
  DownloadLog = async ({ token, cache, searchText, from, to } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `log/download?cache=${cache}&searchText=${searchText}&from=${from}&to=${to}`,
      project: "cscore.quantrac",
      fileName: "DS_Log.xlsx"
    });
  }

  tongso_gp = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `Dashboard/tongso`,
      project: "cscore.quantrac"
    });
  };

  thanhphanmoitruong = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `Dashboard/tongso_tpmt`,
      project: "cscore.quantrac"
    });
  };



  //TODO: [Common] Dashboard thống kế biểu đồ cột
  Get_API_Dashboard_BieuDoCot = async ({ token, tunam, dennam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `Dashboard/thongke_bcdk_bieudocot`,
      project: "cscore.quantrac",
      data: { tunam, dennam }
    });
  }

  //TODO: [Common] GET trees QTVHL
  Get_VHL_BaoCaoDinhKy = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy/Get_Trees`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET  QTVHL 
  GetVHL_BaoCaoDinhKys = async ({ token, strSearch, page, size, kybaocao } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, kybaocao }
    });
  };

  //TODO: [Common] GET  QTVHL 
  GetVHL_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET  QTVHL KQQT
  GetBCDK_KQQT_VHL = async ({ token, tpmt_ma, idbaocao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, idbaocao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] Post QTVHL 
  PostVHL_BaoCaoDinhKy = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put QTVHL
  PutVHL_BaoCaoDinhKy = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy/PutVHL_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] GET danh sach kqqt VHL theo thong so
  GetBCDK_KQQT_By_ThongSo_VHL = async ({ token, thongso_id, id_TramQT, kybaocao, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, id_TramQT, kybaocao, tpmt_ma, idDMQCVN, idMDSD }
    });
  };

  //TODO: [Common] Delete VHL
  DeleteVHL_BaoCaoDinhKy = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy/DeleteVHL_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] GET thiet lap mau kqqt htmt
  Get_BCDK_ThietLapMau_VHL = async ({ token, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_BaoCaoDinhKy/Get_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau htmt
  Post_BCDK_ThietLapMau_VHL = async ({ token, thietlapmaus, tpmt_ma, nam } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy/Post_BCDK_ThietLapMau?tpmt_ma=${tpmt_ma}&nam=${nam}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET tram vhl
  GetVHL_TramQuanTracs = async ({ token, strSearch, page, size, tpmt_ma, idbaocao } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, tpmt_ma, idbaocao }
    });
  };
  //TODO: [Common] GET tram vhl by id
  GetVHL_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };
  //TODO: [Common] Post tram vhl
  PostVHL_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put tram vhl
  PutVHL_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).putData({
      path: `VHL_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Delete VHL
  DeleteVHL_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `VHL_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  GetTPMT_Exist_VHL = async ({ token, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/TPMT_Exist`,
      project: "cscore.quantrac",
      data: { id_tramqt }
    });
  };

  GetThongSos_Exist_VHL = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/ThongSos_Exist`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetMauQTs_By_TramQT_VHL = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/MauQTs_By_TramQT`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_SoLanVuotNguong_VHL = async ({ token, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/BieuDo_SoLanVuotNguong`,
      project: "cscore.quantrac",
      data: { tpmt_ma, id_tramqt }
    });
  };

  GetBieuDo_ThongSos_GiaTris_Timeline_VHL = async ({ token, idthongso, idthongso2, tpmt_ma, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `VHL_TramQuanTrac/BieuDo_ThongSos_GiaTris_Timeline`,
      project: "cscore.quantrac",
      data: { idthongso, idthongso2, tpmt_ma, id_tramqt }
    });
  };

  //TODO: [Common] GET thong so by dmqcvn
  GetQT_DMQCVN_ThongSos = async ({ token, iddmqcvn } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_ThongSos?iddmqcvn=${iddmqcvn}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thong so by dmqcvn
  PostQT_DMQCVN_ThongSos = async ({ token, iddmqcvn, tenDMQCVN, objs } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QT_DMQCVN_ThongSos?iddmqcvn=${iddmqcvn}&tenDMQCVN=${tenDMQCVN}`,
      project: "cscore.quantrac",
      data: objs
    });
  };

  //TODO: [Common] GET  QDXP
  GetTT_QDXPs = async ({ token, maHuyen, namQD, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP`,
      project: "cscore.quantrac",
      data: { maHuyen, namQD, strSearch, page, size }
    });
  };

  //TODO: [Common] GET  QDXP by doanh nghiep
  GetTT_QDXPs_By_DoanhNghiep = async ({ token, iddoanhnghiep, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP`,
      project: "cscore.quantrac",
      data: { iddoanhnghiep, page, size }
    });
  };

  //TODO: [Common] GET  QDXP by id
  GetTT_QDXP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post QDXP 
  PostTT_QDXP = async ({ token, objQD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP`,
      project: "cscore.quantrac",
      data: objQD
    });
  };

  //TODO: [Common] Put QDXP
  PutTT_QDXP = async ({ token, id, objQD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP/PutTT_QDXP?id=${id}`,
      project: "cscore.quantrac",
      data: objQD
    });
  };

  //TODO: [Common] Delete QDXP
  DeleteTT_QDXP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP/DeleteTT_QDXP?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET kqqt QDXP
  GetKQQT = async ({ token, thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP/KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] GET kqqt by thong so
  GetKQQT_By_ThongSo = async ({ token, thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD }
    });
  };

  //TODO: [Common] GET  QDXP tram qt
  GetTT_QDXP_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET  QDXP tram qt by doanh nghiep
  GetTT_QDXP_TramQuanTracs_By_QD = async ({ token, idThongTinChung, page, size, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP_TramQuanTrac/ByQD`,
      project: "cscore.quantrac",
      data: { idThongTinChung, page, size, tpmt_ma }
    });
  };

  //TODO: [Common] GET  QDXP tram qt by id
  GetTT_QDXP_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_QDXP_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post QDXP tram qt
  PostTT_QDXP_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put QDXP tram qt
  PutTT_QDXP_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP_TramQuanTrac/PutTT_QDXP_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete QDXP tram qt
  DeleteTT_QDXP_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP_TramQuanTrac/DeleteTT_QDXP_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };


  //TODO: [Common] GET du an
  GetDMDuAns = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DMDuAn`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET du an by id
  GetDMDuAn = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DMDuAn/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post du an
  PostDMDuAn = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DMDuAn`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put du an
  PutDMDuAn = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DMDuAn/PutDMDuAn?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete du an
  DeleteDMDuAn = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DMDuAn/DeleteDMDuAn?id=${id}`,
      project: "cscore.quantrac",
    });
  };
  // TODO:deleta file CV BVMT
  DeleteExcelKQQT_BVMT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV BVMT
  UploadExcelKQQT_BVMT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `BVMT/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV BVMT
  GetExcelFromThietLapConvert_BVMT = async ({ token, sheetname, cot_kyquantrac, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `BVMT/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_kyquantrac=${cot_kyquantrac}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'BVMT_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel BVMT
  ConvertExcelKQQT_BVMT = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, cot_kyquantrac, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&cot_kyquantrac=${cot_kyquantrac}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO:deleta file CV DTM
  DeleteExcelKQQT_DTM = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV DTM
  UploadExcelKQQT_DTM = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `DTM/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV DTM
  GetExcelFromThietLapConvert_DTM = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DTM/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'DTM_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel DTM
  ConvertExcelKQQT_DTM = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, cot_kyquantrac, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&cot_kyquantrac=${cot_kyquantrac}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO:deleta file CV HTMT
  DeleteExcelKQQT_HTMT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV HTMT
  UploadExcelKQQT_HTMT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `HTMT_BaoCaoDinhKy/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV HTMT
  GetExcelFromThietLapConvert_HTMT = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `HTMT_BaoCaoDinhKy/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'HTMT_Mau_Convert_KQQT.xlsx'
    });
  }

  // TODO: CV Excel HTMT
  ConvertExcelKQQT_HTMT = async ({ token, tpmt_ma, filename, sheetname, dongbatdau, dongketthuc, dong_cmax, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `HTMT_BaoCaoDinhKy/ConvertExcelKQQT?tpmt_ma=${tpmt_ma}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&dong_cmax=${dong_cmax}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO:deleta file CV DTM BCDK
  DeleteExcelKQQT_DTM_BCDK = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV DTM BCDK
  UploadExcelKQQT_DTM_BCDK = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `DTM_BaoCaoDinhKy/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV DTM BCDK
  GetExcelFromThietLapConvert_DTM_BCDK = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DTM_BaoCaoDinhKy/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'DTM_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel DTM BCDK
  ConvertExcelKQQT_DTM_BCDK = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO:deleta file CV BVMT BCDK
  DeleteExcelKQQT_BVMT_BCDK = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV BVMT BCDK
  UploadExcelKQQT_BVMT_BCDK = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `BVMT_BaoCaoDinhKy/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV BVMT BCDK
  GetExcelFromThietLapConvert_BVMT_BCDK = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `BVMT_BaoCaoDinhKy/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'KSON_Mau_Convert_KQQT.xlsx'
    });
  }

  // TODO: CV Excel BVMT BCDK
  ConvertExcelKQQT_BVMT_BCDK = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&dong_cmax=${dong_cmax}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO:deleta file CV NTTS
  DeleteExcelKQQT_NTTS = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV NTTS
  UploadExcelKQQT_NTTS = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `NTTS_BaoCaoDinhKy/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV NTTS
  GetExcelFromThietLapConvert_NTTS = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `NTTS_BaoCaoDinhKy/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'NTTS_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel NTTS
  ConvertExcelKQQT_NTTS = async ({ token, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `NTTS_BaoCaoDinhKy/ConvertExcelKQQT?tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };
  // TODO: UPLOAD FILE CV VHL
  UploadExcelKQQT_VHL = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `VHL_BaoCaoDinhKy/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO:deleta file CV VHL
  DeleteExcelKQQT_VHL = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: get thiet lap mau CV VHL
  GetExcelFromThietLapConvert_VHL = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `VHL_BaoCaoDinhKy/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'VHL_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel VHL
  ConvertExcelKQQT_VHL = async ({ token, tpmt_ma, filename, sheetname, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `VHL_BaoCaoDinhKy/ConvertExcelKQQT?tpmt_ma=${tpmt_ma}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // TODO: UPLOAD FILE CV QDXP
  UploadExcelKQQT_QDXP = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `TT_QDXP/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO:deleta file CV QDXP
  DeleteExcelKQQT_QDXP = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  GetExcelFromThietLapConvert_QDXP = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `TT_QDXP/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'QDXP_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel QDXP
  ConvertExcelKQQT_QDXP = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_QDXP/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };
  GetExcelDanhGiaKQQT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DTM/GetExcelDanhGiaKQQT`,
      project: "cscore.quantrac",
      data: data,
      fileName: 'DTM_Mau_Convert_KQQT.xlsx'
    });
  }

  //TODO: [Common] GET  QDXP
  GetCAT_QDXPs = async ({ token, maHuyen, namQD, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP`,
      project: "cscore.quantrac",
      data: { maHuyen, namQD, strSearch, page, size }
    });
  };

  //TODO: [Common] GET  QDXP by doanh nghiep
  GetCAT_QDXPs_By_DoanhNghiep = async ({ token, iddoanhnghiep, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP`,
      project: "cscore.quantrac",
      data: { iddoanhnghiep, page, size }
    });
  };

  //TODO: [Common] GET  QDXP by id
  GetCAT_QDXP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post QDXP 
  PostCAT_QDXP = async ({ token, objQD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP`,
      project: "cscore.quantrac",
      data: objQD
    });
  };

  //TODO: [Common] Put QDXP
  PutCAT_QDXP = async ({ token, id, objQD } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP/PutCAT_QDXP?id=${id}`,
      project: "cscore.quantrac",
      data: objQD
    });
  };

  //TODO: [Common] Delete QDXP
  DeleteCAT_QDXP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP/DeleteCAT_QDXP?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET kqqt QDXP
  GetKQQT_CAT = async ({ token, thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP/KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] GET kqqt by thong so
  GetKQQT_By_ThongSo_CAT = async ({ token, thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, id_TramQT, tpmt_ma, idDMQCVN, idMDSD }
    });
  };

  // TODO: UPLOAD FILE CV QDXP
  UploadExcelKQQT_CAT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `CAT_QDXP/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO:deleta file CV QDXP
  DeleteExcelKQQT_CAT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  GetExcelFromThietLapConvert_CAT = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `CAT_QDXP/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'QDXP_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel QDXP
  ConvertExcelKQQT_CAT = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  //TODO: [Common] GET  QDXP tram qt
  GetCAT_QDXP_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET  QDXP tram qt by doanh nghiep
  GetCAT_QDXP_TramQuanTracs_By_QD = async ({ token, idThongTinChung, page, size, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP_TramQuanTrac/ByQD`,
      project: "cscore.quantrac",
      data: { idThongTinChung, page, size, tpmt_ma }
    });
  };

  //TODO: [Common] GET  QDXP tram qt by id
  GetCAT_QDXP_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_QDXP_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post QDXP tram qt
  PostCAT_QDXP_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put QDXP tram qt
  PutCAT_QDXP_TramQuanTrac = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP_TramQuanTrac/PutCAT_QDXP_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete QDXP tram qt
  DeleteCAT_QDXP_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_QDXP_TramQuanTrac/DeleteCAT_QDXP_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET  KHTKT tram qt
  GetTT_KeHoach_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET  KHTKT tram qt by doanh nghiep
  GetTT_KeHoach_TramQuanTracs_By_KeHoach = async ({ token, thongtinchung_id, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach_TramQuanTrac/ByKeHoach`,
      project: "cscore.quantrac",
      data: { thongtinchung_id, page, size }
    });
  };

  //TODO: [Common] GET  KHTKT tram qt by id
  GetTT_KeHoach_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post KHTKT tram qt
  PostTT_KeHoach_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put KHTKT tram qt
  PutTT_KeHoach_TramQuanTrac = async ({ token, id, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach_TramQuanTrac/PutTT_KeHoach_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Delete KHTKT tram qt
  DeleteTT_KeHoach_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach_TramQuanTrac/DeleteTT_KeHoach_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //

  //TODO: [Common] GET  KHTKT
  GetTT_KeHoachs = async ({ token, strSearch, page, size, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, nam }
    });
  };

  //TODO: [Common] GET  KHTKT by id
  GetTT_KeHoach = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post KHTKT 
  PostTT_KeHoach = async ({ token, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Put KHTKT
  PutTT_KeHoach = async ({ token, id, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/PutTT_KeHoach?id=${id}`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Delete KHTKT
  DeleteTT_KeHoach = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/DeleteTT_KeHoach?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET  KHTKT thiet lap mau
  Get_ThietLapMau_KHTKT = async ({ token, idThongTinChung, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach/Get_ThietLapMau`,
      project: "cscore.quantrac",
      data: { idThongTinChung, tpmt_ma }
    });
  };

  Post_ThietLapMau_KHTKT = async ({ token, idThongTinChung, thietlapmaus, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/Post_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET  KHTKT kqqt
  GetKQQT_KHTKT = async ({ token, id_kehoach_kqqt, tpmt_ma, id_dmqcvn, id_mdsd } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TT_KeHoach/KQQT`,
      project: "cscore.quantrac",
      data: { id_kehoach_kqqt, tpmt_ma, id_dmqcvn, id_mdsd }
    });
  };

  // TODO:deleta file CV KHTKT
  DeleteExcelKQQT_KHTKT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV KHTKT
  UploadExcelKQQT_KHTKT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `TT_KeHoach/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV KHTKT
  GetExcelFromThietLapConvert_KHTKT = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `TT_KeHoach/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'HTMT_Mau_Convert_KQQT.xlsx'
    });
  }

  // TODO: CV Excel KHTKT
  ConvertExcelKQQT_KHTKT = async ({ token, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/ConvertExcelKQQT?tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // CAT

  //TODO: [Common] GET  CAT_KH tram qt
  GetCAT_KeHoach_TramQuanTracs = async ({ token, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach_TramQuanTrac`,
      project: "cscore.quantrac",
      data: { strSearch, page, size }
    });
  };

  //TODO: [Common] GET  CAT_KH tram qt by doanh nghiep
  GetCAT_KeHoach_TramQuanTracs_By_KeHoach = async ({ token, thongtinchung_id, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach_TramQuanTrac/ByKeHoach`,
      project: "cscore.quantrac",
      data: { thongtinchung_id, page, size }
    });
  };

  //TODO: [Common] GET  CAT_KH tram qt by id
  GetCAT_KeHoach_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach_TramQuanTrac/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post CAT_KH tram qt
  PostCAT_KeHoach_TramQuanTrac = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach_TramQuanTrac`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Put CAT_KH tram qt
  PutCAT_KeHoach_TramQuanTrac = async ({ token, id, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach_TramQuanTrac/PutCAT_KeHoach_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Delete CAT_KH tram qt
  DeleteCAT_KeHoach_TramQuanTrac = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach_TramQuanTrac/DeleteCAT_KeHoach_TramQuanTrac?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //

  //TODO: [Common] GET  CAT_KH
  GetCAT_KeHoachs = async ({ token, strSearch, page, size, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, nam }
    });
  };

  //TODO: [Common] GET  CAT_KH by id
  GetCAT_KeHoach = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post CAT_KH 
  PostCAT_KeHoach = async ({ token, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Put CAT_KH
  PutCAT_KeHoach = async ({ token, id, objInput } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/PutCAT_KeHoach?id=${id}`,
      project: "cscore.quantrac",
      data: objInput
    });
  };

  //TODO: [Common] Delete CAT_KH
  DeleteCAT_KeHoach = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/DeleteCAT_KeHoach?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET CAT_KH kqqt
  GetKQQT_CAT_KH = async ({ token, id_kehoach_kqqt, tpmt_ma, id_dmqcvn, id_mdsd } = {}) => {
    return new APIService({ token: token }).getData({
      path: `CAT_KeHoach/KQQT`,
      project: "cscore.quantrac",
      data: { id_kehoach_kqqt, tpmt_ma, id_dmqcvn, id_mdsd }
    });
  };

  // TODO:deleta file CV CAT_KH
  DeleteExcelKQQT_CAT_KH = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV CAT_KH
  UploadExcelKQQT_CAT_KH = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `CAT_KeHoach/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV CAT_KH
  GetExcelFromThietLapConvert_CAT_KH = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `CAT_KeHoach/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'HTMT_Mau_Convert_KQQT.xlsx'
    });
  }

  // TODO: CV Excel CAT_KH
  ConvertExcelKQQT_CAT_KH = async ({ token, tpmt_ma, filename, sheetname, dongbatdau, dong_cmax, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/ConvertExcelKQQT?tpmt_ma=${tpmt_ma}&filename=${filename}&dongbatdau=${dongbatdau}&dong_cmax=${dong_cmax}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  //TODO: [Common] GET QCVN+MD
  GetQT_DMQCVN_MDSD = async ({ token, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_TNN/DMQCVN_MDSD?tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET QCVN+MD
  GetQT_DMQCVN_MDSD_All = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QT_DMQCVN_TNN/DMQCVN_MDSD_All`,
      project: "cscore.quantrac",
    });
  };

  // ĐTM doanh nghiep
  //TODO: [Common] GET phe duyet bao cao
  PheDuyetBCDK_Temp = async ({ token, id, trangthai, comment } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/PheDuyetBCDK_Temp`,
      project: "cscore.quantrac",
      data: { id, trangthai, comment }
    });
  };

  //TODO: [Common] GET DTM BCDK DN Temp
  GetDTM_BaoCaoDinhKys_DN_Temp = async ({ token, strSearch, page, size, idQD, kybaocao, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/GetDTM_BaoCaoDinhKys_DoanhNghiep`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, idQD, kybaocao, trangthai }
    });
  };

  //TODO: [Common] GET DTM BCDK CV Temp
  GetDTM_BaoCaoDinhKys_CV_Temp = async ({ token, strSearch, page, size, idQD, kybaocao, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/GetDTM_BaoCaoDinhKys_CV`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, idQD, kybaocao, trangthai }
    });
  };

  //TODO: [Common] GET DTM BCDK Temp by id
  GetDTM_BaoCaoDinhKy_Temp = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post DTM BCDK Temp
  PostDTM_BaoCaoDinhKy_Temp = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put DTM BCDK Temp
  PutDTM_BaoCaoDinhKy_Temp = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp/PutDTM_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete DTM bcdk Temp
  DeleteDTM_BaoCaoDinhKy_Temp = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp/DeleteDTM_BaoCaoDinhKy?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thiet lap mau DTM BCDK Temp by idThongTinChung
  Get_BCDK_ThietLapMau_DTM_Temp = async ({ token, idThongTinChung, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/Get_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET DTM BCDK_By_QD Temp
  GetBCDK_By_QD_DTM_Temp = async ({ token, thongtinchung_id, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/BCDK_By_QD`,
      data: { thongtinchung_id, nam },
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET DTM BCDK_By_QD Temp
  GetDTM_BaoCaoDinhKyBySoQD_Temp = async ({ token, soquyetdinh, ngayky } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/GetDTM_BaoCaoDinhKyBySoQD`,
      data: { soquyetdinh, ngayky },
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau DTM BCDK Temp by idThongTinChung
  Post_BCDK_ThietLapMau_DTM_Temp = async ({ token, idThongTinChung, thietlapmaus, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp/Post_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET tree DTM BCDK Temp
  Get_DTM_BaoCaoDinhKy_Temp = async ({ token, kybaocao, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/Get_Trees`,
      project: "cscore.quantrac",
      data: { kybaocao, strSearch, page, size }
    });
  };

  //TODO: [Common] GET BCDK
  GetDSGiayPhepByBCDK = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/GetDSGiayPhepByBCDK`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc của báo cáo định kỳ theo báo cáo phê duyệt DTM Temp
  GetBCDK_KQQT_DTM_Temp = async ({ token, thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc theo thong so DTM Temp
  GetBCDK_KQQT_By_ThongSo_DTM_Temp = async ({ token, thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_BaoCaoDinhKy_Temp/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT }
    });
  };

  // TODO:deleta file CV DTM BCDK
  DeleteExcelKQQT_DTM_BCDK_Temp = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV DTM BCDK
  UploadExcelKQQT_DTM_BCDK_Temp = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `DTM_BaoCaoDinhKy_Temp/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV DTM BCDK
  GetExcelFromThietLapConvert_DTM_BCDK_Temp = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DTM_BaoCaoDinhKy_Temp/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'DTM_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel DTM BCDK
  ConvertExcelKQQT_DTM_BCDK_Temp = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_BaoCaoDinhKy_Temp/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&filename=${filename}&dong_cmax=${dong_cmax}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };

  // BVMT doanh nghiep
  //TODO: [Common] GET phe duyet bao cao
  PheDuyetBCDK_BVMT_Temp = async ({ token, id, trangthai, comment } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/PheDuyetBCDK_Temp`,
      project: "cscore.quantrac",
      data: { id, trangthai, comment }
    });
  };

  //TODO: [Common] GET BVMT BCDK DN Temp
  GetBVMT_BaoCaoDinhKys_DoanhNghiep_Temp = async ({ token, strSearch, page, size, idQD, kybaocao, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/GetBVMT_BaoCaoDinhKys_DoanhNghiep`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, idQD, kybaocao, trangthai }
    });
  };

  //TODO: [Common] GET BVMT BCDK CV Temp
  GetBVMT_BaoCaoDinhKys_CV_Temp = async ({ token, strSearch, page, size, idQD, kybaocao, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/GetBVMT_BaoCaoDinhKys_CV`,
      project: "cscore.quantrac",
      data: { strSearch, page, size, idQD, kybaocao, trangthai }
    });
  };

  //TODO: [Common] GET BVMT BCDK Temp by id
  GetBVMT_BaoCaoDinhKy_Temp = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post BVMT BCDK Temp
  PostBVMT_BaoCaoDinhKy_Temp = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp`,
      project: "cscore.quantrac",
      data: data
    });
  };
  //TODO: [Common] Put BVMT BCDK Temp
  PutBVMT_BaoCaoDinhKy_Temp = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp/Put_BCDK_Temp?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };

  //TODO: [Common] Delete BVMT bcdk Temp
  DeleteBVMT_BaoCaoDinhKy_Temp = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp/Delete_BCDK_Temp?id=${id}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET thiet lap mau BVMT BCDK Temp by idThongTinChung
  Get_BCDK_ThietLapMau_BVMT_Temp = async ({ token, idThongTinChung, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/Get_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET BVMT BCDK_By_QD Temp
  GetBCDK_By_QD_BVMT_Temp = async ({ token, thongtinchung_id, nam } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/BCDK_By_QD`,
      data: { thongtinchung_id, nam },
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] GET BVMT BCDK_By_QD Temp
  GetBVMT_BaoCaoDinhKyBySoQD_Temp = async ({ token, soquyetdinh, ngayky } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/GetBVMT_BaoCaoDinhKyBySoQD`,
      data: { soquyetdinh, ngayky },
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] Post thiet lap mau BVMT BCDK Temp by idThongTinChung
  Post_BCDK_ThietLapMau_BVMT_Temp = async ({ token, idThongTinChung, thietlapmaus, tpmt_ma } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp/Post_BCDK_ThietLapMau?idThongTinChung=${idThongTinChung}&tpmt_ma=${tpmt_ma}`,
      project: "cscore.quantrac",
      data: thietlapmaus
    });
  };

  //TODO: [Common] GET tree BVMT BCDK Temp
  Get_BVMT_BaoCaoDinhKy_Temp = async ({ token, kybaocao, strSearch, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/Get_Trees`,
      project: "cscore.quantrac",
      data: { kybaocao, strSearch, page, size }
    });
  };

  //TODO: [Common] GET BCDK BVMT
  GetDSGiayPhepByBCDK_BVMT = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/GetDSGiayPhepByBCDK`,
      project: "cscore.quantrac",
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc của báo cáo định kỳ theo báo cáo phê duyệt BVMT Temp
  GetBCDK_KQQT_BVMT_Temp = async ({ token, thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/BCDK_KQQT`,
      project: "cscore.quantrac",
      data: { thongTinChung_Id, tpmt_ma, kyBaoCao, idDMQCVN, idMDSD, id_tramqt }
    });
  };

  //TODO: [Common] get danh sách kết quả quan trắc theo thong so BVMT Temp
  GetBCDK_KQQT_By_ThongSo_BVMT_Temp = async ({ token, thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_BaoCaoDinhKy_Temp/KQQT_By_ThongSo`,
      project: "cscore.quantrac",
      data: { thongso_id, thongtinchung_id, tpmt_ma, kybaocao, idDMQCVN, idMDSD, id_TramQT }
    });
  };

  // TODO:deleta file CV BVMT BCDK
  DeleteExcelKQQT_BVMT_BCDK_Temp = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp/DeleteExcelKQQT?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV BVMT BCDK
  UploadExcelKQQT_BVMT_BCDK_Temp = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `BVMT_BaoCaoDinhKy_Temp/UploadExcelKQQT`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV BVMT BCDK
  GetExcelFromThietLapConvert_BVMT_BCDK_Temp = async ({ token, sheetname, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `BVMT_BaoCaoDinhKy_Temp/GetExcelFromThietLapConvert?sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso,
      fileName: 'BVMT_Mau_Convert_KQQT.xlsx'
    });
  }
  // TODO: CV Excel BVMT BCDK
  ConvertExcelKQQT_BVMT_BCDK_Temp = async ({ token, thongtinchungid, tpmt_ma, filename, sheetname, dong_cmax, dongbatdau, dongketthuc, cot_mau_kyhieu, cot_mau_ten, cot_mau_tinhtrang, cot_mau_mota, cot_donvithuchien, cot_nguoilaymaus, cot_nguoigiamsats, cot_ngaylaymau, cot_ngaynhanmau, cot_ngayphantich, cot_dotQuanTracSo, cot_dotQuanTrac_Ten, cot_vitriquantrac, cot_vitriquantrac_diadiem, cot_vitriquantrac_x, cot_vitriquantrac_y, cot_thongsodautien, list_thongso, kyhieuBoQua, kyhieuLonHon, kyHieuNhoHon } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_BaoCaoDinhKy_Temp/ConvertExcelKQQT?thongtinchungid=${thongtinchungid}&tpmt_ma=${tpmt_ma}&dong_cmax=${dong_cmax}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}&cot_mau_kyhieu=${cot_mau_kyhieu}&cot_mau_ten=${cot_mau_ten}&cot_mau_tinhtrang=${cot_mau_tinhtrang}&cot_mau_mota=${cot_mau_mota}&cot_donvithuchien=${cot_donvithuchien}&cot_nguoilaymaus=${cot_nguoilaymaus}&cot_nguoigiamsats=${cot_nguoigiamsats}&kyhieuBoQua=${kyhieuBoQua}&kyhieuLonHon=${kyhieuLonHon}&kyHieuNhoHon=${kyHieuNhoHon}&cot_ngaylaymau=${cot_ngaylaymau}&cot_ngaynhanmau=${cot_ngaynhanmau}&cot_ngayphantich=${cot_ngayphantich}&cot_dotQuanTracSo=${cot_dotQuanTracSo}&cot_dotQuanTrac_Ten=${cot_dotQuanTrac_Ten}&cot_vitriquantrac=${cot_vitriquantrac}&cot_vitriquantrac_diadiem=${cot_vitriquantrac_diadiem}&cot_vitriquantrac_x=${cot_vitriquantrac_x}&cot_vitriquantrac_y=${cot_vitriquantrac_y}&cot_thongsodautien=${cot_thongsodautien}`,
      project: "cscore.quantrac",
      data: list_thongso
    });
  };
  //dtm Temp
  PostDTM_TramQuanTrac_Temp = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DTM_TramQuanTrac_Temp`,
      project: "cscore.quantrac",
      data: data
    });
  };
  GetDTM_TramQuanTracs_By_DTM_Temp = async ({ token, idThongTinChung, page, size, tpmt_ma } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DTM_TramQuanTrac_Temp/ByDTM`,
      data: { idThongTinChung, page, size, tpmt_ma },
      project: "cscore.quantrac"
    });
  };

  // bvmt temp 
  PostBVMT_TramQuanTrac_Temp = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `BVMT_TramQuanTrac_Temp`,
      project: "cscore.quantrac",
      data: data
    });
  };
  GetBVMT_TramQuanTracs_By_BVMT_Temp = async ({ token, idThongTinChung, tpmt_ma, page, size } = {}) => {
    return new APIService({ token: token }).getData({
      path: `BVMT_TramQuanTrac_Temp/ByBVMT`,
      project: "cscore.quantrac",
      data: { idThongTinChung, page, size, tpmt_ma }
    });
  };
  //api ban do
  GetDuLieuByDiemQT = async ({ token, url } = {}) => {
    return new APIService({ token: token }).getData({
      path: `ApiBanDo/GetDuLieuByDiemQT`,
      data: { url },
      project: "cscore.quantrac"
    });
  };
  //
  DownloadFileHDSD = async ({ token } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `HDSD/download`,
      project: "cscore.quantrac",
      fileName: "HDSD.pdf",
    });
  }

  //convert form excel KQ TTKT
  // TODO:deleta file CV 
  KQThanhTra_DeleteExcelMau_TTKT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/KQThanhTra_DeleteExcelMau?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV 
  KQThanhTra_UploadExcelMau_TTKT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `TT_KeHoach/KQThanhTra_UploadExcelMau`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV 
  GetKQThanhTra_ExcelMau_TTKT = async ({ token } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `TT_KeHoach/KQThanhTra_ExcelMau`,
      project: "cscore.quantrac",
      fileName: 'KH_ThanhKiemTra.xlsx'
    });
  }
  // TODO: CV Excel
  KQThanhTra_ConvertExcel_TTKT = async ({ token, thongtinchung_id, filename, sheetname, dongbatdau, dongketthuc } = {}) => {
    return new APIService({ token: token }).postData({
      path: `TT_KeHoach/KQThanhTra_ConvertExcel?thongtinchung_id=${thongtinchung_id}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}`,
      project: "cscore.quantrac",
    });
  };

  //convert form excel CAT KQ TTKT
  // TODO:deleta file CV 
  KQThanhTra_DeleteExcelMau_TTKT_CAT = async ({ token, filename } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/KQThanhTra_DeleteExcelMau?filename=${filename}`,
      project: "cscore.quantrac"
    });
  };
  // TODO: UPLOAD FILE CV 
  KQThanhTra_UploadExcelMau_TTKT_CAT = async ({ token, data } = {}) => {
    return new APIServiceFile({ token: token }).postDataUp({
      path: `CAT_KeHoach/KQThanhTra_UploadExcelMau`,
      project: "cscore.quantrac",
      data: data,
    });
  }
  // TODO: get thiet lap mau CV 
  GetKQThanhTra_ExcelMau_TTKT_CAT = async ({ token } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `CAT_KeHoach/KQThanhTra_ExcelMau`,
      project: "cscore.quantrac",
      fileName: 'KH_ThanhKiemTra.xlsx'
    });
  }
  // TODO: CV Excel
  KQThanhTra_ConvertExcel_TTKT_CAT = async ({ token, thongtinchung_id, filename, sheetname, dongbatdau, dongketthuc } = {}) => {
    return new APIService({ token: token }).postData({
      path: `CAT_KeHoach/KQThanhTra_ConvertExcel?thongtinchung_id=${thongtinchung_id}&filename=${filename}&dongbatdau=${dongbatdau}&dongketthuc=${dongketthuc}&sheetname=${sheetname}`,
      project: "cscore.quantrac",
    });
  };


  //De nghi cap nhat
  GetDeNghiCapNhatCPs_For_DN = async ({ token, strSearch, page, size, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DoanhNghiep_DeNghiCapNhatCP/GetDeNghiCapNhatCPs_For_DN`,
      data: { strSearch, page, size, trangthai },
      project: "cscore.quantrac"
    });
  };
  GetDeNghiCapNhatCPs_CV = async ({ token, strSearch, page, size, trangthai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DoanhNghiep_DeNghiCapNhatCP/GetDeNghiCapNhatCPs_CV`,
      data: { strSearch, page, size, trangthai },
      project: "cscore.quantrac"
    });
  };
  GetDoanhNghiep_DeNghiCapNhatCP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DoanhNghiep_DeNghiCapNhatCP/${id}`,
      project: "cscore.quantrac"
    });
  };
  PostDoanhNghiep_DeNghiCapNhatCP = async ({ token, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DoanhNghiep_DeNghiCapNhatCP`,
      data: data,
      project: "cscore.quantrac",
    });
  };
  PutDoanhNghiep_DeNghiCapNhatCP = async ({ token, id, data } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DoanhNghiep_DeNghiCapNhatCP/PutDoanhNghiep_DeNghiCapNhatCP?id=${id}`,
      project: "cscore.quantrac",
      data: data
    });
  };
  DeleteDoanhNghiep_DeNghiCapNhatCP = async ({ token, id } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DoanhNghiep_DeNghiCapNhatCP/DeleteDoanhNghiep_DeNghiCapNhatCP?id=${id}`,
      project: "cscore.quantrac",
    });
  };
  //Gui email
  NoiDung_Email_YeuCauBCDK_DTM = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DoanhNghiep_ThongBao/NoiDung_Email_YeuCauBCDK_DTM`,
      project: "cscore.quantrac",
    });
  };
  Luu_Email_YeuCauBCDK_DTM = async ({ token, tongso } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DoanhNghiep_ThongBao/Luu_Email_YeuCauBCDK_DTM`,
      project: "cscore.quantrac",
      data: tongso
    });
  };
  NoiDung_Email_YeuCauBCDK_BVMT = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `DoanhNghiep_ThongBao/NoiDung_Email_YeuCauBCDK_BVMT`,
      project: "cscore.quantrac",
    });
  };
  Luu_Email_YeuCauBCDK_BVMT = async ({ token, tongso } = {}) => {
    return new APIService({ token: token }).postData({
      path: `DoanhNghiep_ThongBao/Luu_Email_YeuCauBCDK_BVMT`,
      project: "cscore.quantrac",
      data: tongso
    });
  };
  //TODO: [Common] Download danh gia KQ quan trac 
  GetBCDK_KQQT_Excel_BVMT = async ({ token, thongTinChung_Id, tpmt_ma, id_tramqt, kyBaoCao, idDMQCVN, idMDSD } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `BVMT_BaoCaoDinhKy/GetBCDK_KQQT_Excel?thongTinChung_Id=${thongTinChung_Id}&tpmt_ma=${tpmt_ma}&id_tramqt=${id_tramqt}&kyBaoCao=${kyBaoCao}&idDMQCVN=${idDMQCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      fileName: 'BCDK_KQQT_BVMT.xlsx'
    });
  }

  GetBCDK_KQQT_Excel_DTM = async ({ token, thongTinChung_Id, tpmt_ma, id_tramqt, kyBaoCao, idDMQCVN, idMDSD } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `DTM_BaoCaoDinhKy/GetBCDK_KQQT_Excel?thongTinChung_Id=${thongTinChung_Id}&tpmt_ma=${tpmt_ma}&id_tramqt=${id_tramqt}&kyBaoCao=${kyBaoCao}&idDMQCVN=${idDMQCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      fileName: 'BCDK_KQQT_DTM.xlsx'
    });
  }

  GetBCDK_KQQT_Excel_HTMT = async ({ token, tpmt_ma, id_tramqt, idDMQCVN, idMDSD } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `HTMT_BaoCaoDinhKy/BCDK_KQQT_Excel?tpmt_ma=${tpmt_ma}&id_tramqt=${id_tramqt}&idDMQCVN=${idDMQCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      fileName: 'BCDK_KQQT_HTMT.xlsx'
    });
  }

  GetBCDK_KQQT_Excel_NTTS = async ({ token, tpmt_ma, id_tramqt, idDMQCVN, idMDSD } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `NTTS_BaoCaoDinhKy/BCDK_KQQT_Excel?tpmt_ma=${tpmt_ma}&id_tramqt=${id_tramqt}&idDMQCVN=${idDMQCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      fileName: 'BCDK_KQQT_NTTS.xlsx'
    });
  }

  GetBCDK_KQQT_Excel_VHL = async ({ token, tpmt_ma, id_tramqt, idDMQCVN, idMDSD } = {}) => {
    return new APIServiceFile({ token: token }).getDataDown({
      path: `VHL_BaoCaoDinhKy/BCDK_KQQT_Excel?tpmt_ma=${tpmt_ma}&id_tramqt=${id_tramqt}&idDMQCVN=${idDMQCVN}&idMDSD=${idMDSD}`,
      project: "cscore.quantrac",
      fileName: 'BCDK_KQQT_VHL.xlsx'
    });
  }
  // dowload excel thống kê bvmt
  DownloadFileDNCBCDK = async ({ token, dulieu_doanhnghiep } = {}) => {
    return new APIServiceFile({ token: token }).postDataDown({
      path: `DTM/Download_DoanhNghiep?cache=no`,
      data: dulieu_doanhnghiep,
      project: "cscore.quantrac",
      fileName: 'DsDoanhNghiep.xlsx'
    });
  }
}